import { ReportCoordinatesOption } from '@app/core/enums/report-coordinates-option.enum';

export const LD_REPORT_COORDINATES_OPTIONS: ReportCoordinatesOption[] = [
  ReportCoordinatesOption.None,
  ReportCoordinatesOption.LatitudeLongitude,
  ReportCoordinatesOption.Project,
];
